/**
 * This enum shows the filter types that the selector or autocomplete component can do
 */

export enum FILTER_TYPE {
    BY_VALUE = 0,
    BY_KEY = 1,
    BY_VALUE_OR_KEY = 2,
    CUSTOM = 3,
}
